<script lang="ts">
import type { Snippet } from 'svelte'

interface Props {
  id: string
  active?: boolean
  extraBottom?: boolean
  background?: string
  slideClass?: string
  children: Snippet
}

let {
  id,
  active = false,
  extraBottom = false,
  background,
  slideClass = '',
  children,
}: Props = $props()
</script>

<div
  class="slide {slideClass}"
  class:active
  class:slide-extra-bottom={extraBottom}
  {id}
  style={background ? `background:${background}` : undefined}
>
  {@render children()}
</div>
